import { useEffect, useRef } from 'react';
import { MdModeEditOutline, MdDelete } from 'react-icons/md';
import '../Styles/main.css';
import noPicture from './Editor/images/no_picture.jpg';

const RestaurantPreview = (props) => {
    const pickerFilter = ['.jpg','.png','.jpeg'];
    const frontPicker = useRef(null);
    const logoPicker = useRef(null);

    const editFront = () => {
        frontPicker.current.click();
    }

    const editLogo = () => {
        logoPicker.current.click();
    }

    useEffect(() => {
        console.log(props.logo.new);
    });

    const handleFrontChange = (e) => {
        let file = e.target.files[0];

        var reader = new FileReader();

        // Callback for read complete
        reader.onload = function(e) {
            props.setFront(e.target.result);
        };

        // Callback for read error
        reader.onerror = function(e) {
        };
        
        reader.readAsDataURL(file);
    }

    const handleLogoChange = (e) => {
        let file = e.target.files[0];

        var reader = new FileReader();

        // Callback for read complete
        reader.onload = function(e) {
            console.log(e.target.result);
            props.setLogo(e.target.result);
        };

        // Callback for read error
        reader.onerror = function(e) {
        };
        
        reader.readAsDataURL(file);
    }

    return (
        //<div style={{background: 'url('+frontPicture+')', backgroundSize: 'cover'}}/>
        <div className="RestaurantPreview">
            <div className='EditTools'>
                <button style={{display: props.front.new ? 'none':'block'}} onClick={(e) => editFront(e)} className="cbtn"><MdModeEditOutline size='1rem' pointerEvents='none'/></button>
                <button style={{display: props.front.new ? 'block':'none'}} onClick={() => {frontPicker.current.value = ''; props.setFront(undefined);}} className="cbtn"><MdDelete size='1rem' pointerEvents='none'/></button>
                <input className='d-none' type='file' accept={pickerFilter} ref={frontPicker} onChange={handleFrontChange} />
            </div>

            <div style={{overflow: 'hidden', textAlign: 'center'}} >
                <img src={props.front.new ? props.front.new:(props.front.current?props.front.current:noPicture)} width='100%' alt='Perfil'/>
            </div>

            <div className="Info bg-white">
                <div style={{position: 'relative'}}>
                    <div className='EditTools' style={{margin: '-0.5rem'}}>
                        <button style={{display: props.logo.new ? 'none':'block'}} onClick={(e) => editLogo(e)} className="cbtn-small"><MdModeEditOutline size='0.7rem' pointerEvents='none'/></button>
                        <button style={{display: props.logo.new ? 'block':'none'}} onClick={() => {logoPicker.current.value = '';props.setLogo(undefined);}} className="cbtn-small"><MdDelete size='0.7rem' pointerEvents='none'/></button>
                        <input className='d-none' type='file' accept={pickerFilter} ref={logoPicker} onChange={handleLogoChange} />
                    </div>
                    <img className="Logo" src={props.logo.new?props.logo.new:(props.logo.current?props.logo.current:noPicture)} alt='logo'/>
                </div>
                <div className="pl-2">
                    <div className="Name"><strong>{props.name}</strong></div>
                    <div className="Legend">{ props.legend.length > 21 ? props.legend.substring(0,20)+'...':props.legend}</div>
                </div>
            </div>
        </div>
    );
}

export default RestaurantPreview;